"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createGenerateClassName = void 0;

var lodash_1 = require("lodash");

var styles_1 = require("@material-ui/core/styles");

var createGenerateClassName = function createGenerateClassName(options) {
  var unifiOptions = {
    productionPrefix: 'unifi'
  };
  var mergedOptions = lodash_1.merge({}, unifiOptions, options);
  return styles_1.createGenerateClassName(mergedOptions);
};

exports.createGenerateClassName = createGenerateClassName;